require('./bootstrap');
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
// require('livewire-sortable');
